import { Box, Typography } from "@mui/material";

export default function RequirementBox({ boxSx, label, data }) {
  return (
    <Box sx={boxSx}>
      <Typography
        sx={{
          fontSize: 12,
          textDecoration: "underline",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: 12,
        }}
      >
        {data}
      </Typography>
    </Box>
  );
}
